import type { OrderStatus } from '@shared/types';

const STATUS_STYLES: Record<OrderStatus, { className: string; useVar?: boolean }> = {
  pending: { className: '', useVar: true },
  authorized: { className: 'bg-blue-400/10 text-blue-400 border-blue-400/20' },
  redirected: { className: '', useVar: true },
  checkout_opened: { className: '', useVar: true },
  payment_initiated: { className: 'bg-blue-500/10 text-blue-400 border-blue-500/30' },
  usdc_received: { className: 'bg-blue-500/10 text-blue-400 border-blue-500/30' },
  forwarding: { className: 'bg-blue-500/10 text-blue-400 border-blue-500/30' },
  completed: { className: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/30' },
  refunded: { className: 'bg-purple-400/10 text-purple-400 border-purple-400/20' },
  failed: { className: 'bg-red-500/10 text-red-400 border-red-500/30' },
  expired: { className: 'bg-zinc-800/60 text-zinc-200 border-zinc-700/50' },
  on_hold: { className: 'bg-amber-500/10 text-amber-400 border-amber-500/30' },
  disputed: { className: 'bg-orange-400/10 text-orange-400 border-orange-400/20' },
};

const STATUS_LABELS: Record<OrderStatus, string> = {
  pending: 'Pending',
  authorized: 'Authorized',
  redirected: 'Redirected',
  checkout_opened: 'Checkout Opened',
  payment_initiated: 'Payment Initiated',
  usdc_received: 'USDC Received',
  forwarding: 'Forwarding',
  completed: 'Completed',
  refunded: 'Refunded',
  failed: 'Failed',
  expired: 'Abandoned',
  on_hold: 'On Hold',
  disputed: 'Disputed',
};

export default function StatusBadge({ status }: { status: OrderStatus }) {
  const style = STATUS_STYLES[status];

  if (style.useVar) {
    return (
      <span
        className="inline-block px-2 py-0.5 text-xs font-mono font-medium rounded"
        style={{
          background: 'var(--dash-hover-bg)',
          color: 'var(--dash-text-muted)',
          border: '1px solid var(--dash-border)',
        }}
      >
        {STATUS_LABELS[status]}
      </span>
    );
  }

  return (
    <span
      className={`inline-block px-2 py-0.5 text-xs font-mono font-medium border rounded ${style.className}`}
    >
      {STATUS_LABELS[status]}
    </span>
  );
}
